import React, {useState} from 'react';
import '../styles/Login.css';
import logoMEA from '../assets/LogoMea.png';
import {useNavigate, useLocation} from "react-router-dom";
import logout from "../assets/logout.png";
import "../styles/Home.css"
import "../styles/BreadCrumbs.css"

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navigateLogin = () => {
        window.localStorage.removeItem('id');
        window.localStorage.removeItem('routes');
        navigate('/');
    };

    const navHome = () => {
        navigate('/home');
    }

    return (
        <>
            <nav className="navbar navbar-expand-lg navbar-light m-0">
                <div className="container-fluid">
                    {/*<a className="">*/}
                        <button className={'btn btn-outline-'}>
                            <img src={logoMEA} id="logoMEA" onClick={navHome}/>
                        </button>
                    {/*</a>*/}
                    <div className={"flex justify-content-end"}>
                        <a>
                            <button className={'btn btn-outline-'}>
                                <img src={logout} onClick={navigateLogin} id="logOut"/>
                            </button>
                        </a>
                    </div>

                </div>
            </nav>
        </>

    );
};

export default Header;